import ListItem from '@/components/List/ListItem'
import ListSection from '@/components/List/ListSection'
import Page from '@/components/Page'
import ThemeSwitcher from '@/components/ThemeSwitcher'
import { css } from '@emotion/react'
import { createFileRoute } from '@tanstack/react-router'
import { useTitle } from 'react-use'

export const Route = createFileRoute('/setting')({
	component: SettingPage,
})

function SettingPage() {
	useTitle(`设置 - 即刻`)

	return (
		<Page
			title="设置"
			css={css`
				min-height: 100vh;
			`}
		>
			<div
				css={css`
					display: flex;
					flex-direction: column;
					height: 100%;

					padding: 0 15px 20px;
				`}
			>
				<ListSection title="外观">
					<ListItem
						css={css`
							grid-template-columns: 1fr auto;
						`}
					>
						<div>主题</div>
						<ThemeSwitcher
							css={css`
								margin-left: auto;
							`}
						/>
					</ListItem>
				</ListSection>
			</div>
		</Page>
	)
}
